import React from "react";
import Image from "components/image";

const Hero = ({ data }) => (
	<section className="flex">
		<div className="w-2/4">
			<h1> {data.title} </h1>
		</div>
		{data?.image &&
			<div className="w-2/4">
				<Image image={data.image.asset} alt={data.image.alt} />
			</div>
		}
	</section>
);

export default Hero;
